import Swiper, {Navigation, Pagination} from 'swiper';

const Advantages = () => {
  const swiper = new Swiper('.js-advantages', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    pagination: {
      el: '.js-advantages-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        const titles = JSON.parse(this.el.dataset.pagination) || [];
        return '<span class="' + className + '">' + titles[index] + '</span>';
      },
    },
  });
}

export default Advantages;
